export default __webpack_public_path__ + "static/media/blogDetail6.9beedccf.png";